import React, { useRef, useState, useEffect } from "react";
import styles from "./DataGrid.module.sass";
import { useGlobalValue } from "../../state/GlobalProvider";
import { UserRoles } from "../../utils/userRoles";
import { checkRolesByOrganizationProject } from "../../utils/roleValidator";
import { SovosLinearProgress } from "mosaic-react";
const Dropzone = ({
  Children,
  childrenProps
}) => {
  const datagridRef = useRef(null);
  const [showDragOverlay, setShowDragOverlay] = useState(false);
  const [showLinearProgress, setShowLinearProgress] = useState(false);
  const {
    user,
    reload,
    params,
    uploadFiles,
    pushNotification,
    i18n
  } = useGlobalValue();
  const dragChange = e => {
    e.stopImmediatePropagation();
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter") {
      setShowDragOverlay(true);
    } else if (e.type === "dragleave" && !e.currentTarget.contains(e.relatedTarget)) {
      setShowDragOverlay(false);
    } else if (e.type === "drop") {
      setShowLinearProgress(true);
      const files = (e.dataTransfer || {
        files: []
      }).files;
      const fileList = [...files].filter(f => f.type === "text/txt" || f.type === "csv" || f.type === "text/csv" || f.type === "text/xml" || f.type === "text/plain" || f.type === "application/xml" || f.type === "application/x-zip-compressed" || f.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || f.type === "application/zip");
      if (fileList.length !== files.length) {
        pushNotification({
          message: i18n`${"Unable to upload file. Supported file types: txt, csv, xml and zip"}`,
          type: "error",
          open: true,
          timeout: "medium"
        });
        setShowDragOverlay(false);
        return false;
      }
      setShowDragOverlay(false);
      uploadFiles(params.projectId, fileList, "", reload, pushNotification).then(() => {
        setShowLinearProgress(false);
        reload && reload();
      });
    }
    return false;
  };
  useEffect(() => {
    const handleDocumentDragOver = e => e.preventDefault();
    const handleDocumentDrop = e => e.preventDefault();
    const canUserUpload = checkRolesByOrganizationProject(user, params.projectId, [UserRoles.ADMIN, UserRoles.OWNER, UserRoles.WRITER, UserRoles.PP_SUPPORT, UserRoles.SUPPORT]);
    if (canUserUpload) {
      document.addEventListener("dragover", handleDocumentDragOver);
      document.addEventListener("drop", handleDocumentDrop);
      datagridRef.current?.addEventListener("dragover", dragChange);
      datagridRef.current?.addEventListener("dragenter", dragChange);
      datagridRef.current?.addEventListener("dragleave", dragChange);
      datagridRef.current?.addEventListener("dragexit", dragChange);
      datagridRef.current?.addEventListener("dragstart", dragChange);
      datagridRef.current?.addEventListener("drop", dragChange);
    }
    return () => {
      document.removeEventListener("dragover", handleDocumentDragOver);
      document.removeEventListener("drop", handleDocumentDrop);
      datagridRef.current?.removeEventListener("dragover", dragChange);
      datagridRef.current?.removeEventListener("dragenter", dragChange);
      datagridRef.current?.removeEventListener("dragleave", dragChange);
      datagridRef.current?.removeEventListener("dragexit", dragChange);
      datagridRef.current?.removeEventListener("dragstart", dragChange);
      datagridRef.current?.removeEventListener("drop", dragChange);
    };
  });
  return /*#__PURE__*/React.createElement("div", {
    ref: datagridRef,
    className: `${styles["root"]}`
  }, showLinearProgress && /*#__PURE__*/React.createElement(SovosLinearProgress, null), showDragOverlay && /*#__PURE__*/React.createElement("div", {
    className: `${styles["dropzone"]}`,
    style: {
      height: "100%"
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      color: "#072448"
    }
  }, "Drop your files here")), /*#__PURE__*/React.createElement(Children, childrenProps));
};
export default Dropzone;